module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('div', {
    staticClass: "thumb-wrap"
  }, [(_vm.galleryPreview && _vm.galleryPreview['sizes']) ? _c('img', {
    attrs: {
      "src": _vm.galleryPreview['sizes']['gallery-thumb']
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isVideo) ? _c('div', {
    staticClass: "play-icon-overlay"
  }, [_vm._m(0)]) : _vm._e()]), _vm._v(" "), _c('figcaption', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.gallery.gallery_name)
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "play-circle"
  }, [_c('i', {
    staticClass: "fa fa-play"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b26860e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gallery/GalleryThumb.vue
// module id = 389
// module chunks = 2